import React from 'react';
import AgendaCard from '../home/AgendaCard';
import SinistroCard from '../home/SinistroCard';
import RenovacaoCard from '../home/RenovacaoCard';
import CotacaoCard from '../home/CotacaoCard';
import PropostaCard from '../home/PropostaCard';

export const PlannerSidebar = () => {
  return (
    <aside className="space-y-4 w-80">
      {/* Cards do Planner - mesmos da Home, exceto Produção */}
      <AgendaCard />
      <RenovacaoCard />
      <CotacaoCard />
      <PropostaCard />
      <SinistroCard />
    </aside>
  );
};